import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import Slider from "react-slick";
import { firebaseData } from "../../firebase/index";
import { getTestTime, getTime, trimText } from "../../utils";
import { Get_bookmark_list, GET_Live_Test, Get_server_time } from "../../gql/queries";
import { useMutation, useQuery } from "@apollo/client";
import moment from "moment";
import { Bookmark_QB } from "../../gql/mutation";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import { decrypt } from "../../utils/crypto";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import ConnectionError from "../common/NoDataFound/ConnectionError";
import { toast } from "react-toastify";
const ArrowButtonPrevious = ({ imgSrc, imgAlt, onClick }) => {
    return (
        <button
            onClick={onClick}
            className="slick-prev slick-arrow">
            <img
                src={imgSrc}
                alt={imgAlt}
            />
        </button>
    );
};

const ArrowButtonNext = ({ imgSrc, imgAlt, onClick }) => {
    return (
        <button
            onClick={onClick}
            className="slick-next slick-arrow">
            <img
                src={imgSrc}
                alt={imgAlt}
            />
        </button>
    );
};

export default function TestLayer() {
    const location = useLocation();
    const navigate = useNavigate()
    const [config, setConfig] = useState();
    const [remoteLoading, setRemoteLoading] = useState(true);
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const packageStatus = JSON.parse(decrypt(localStorage.getItem('packageStatus')))
    const [getBookmark] = useMutation(Bookmark_QB, {
        refetchQueries: [
            {
                query: Get_bookmark_list,
                variables: {
                    "contentType": "Test",
                    "courseName": course.preparingFor,
                    "page": 1,
                    "perPage": 1000
                },
            }, // DocumentNode object parsed with gql
            'profileBookMarksList' // Query name,

        ],
    });

    const query3 = useQuery(Get_server_time)
    const query1 = useQuery(GET_Live_Test, {
        variables: {
            "course": course.preparingFor,
        },
    });
    const query2 = useQuery(Get_bookmark_list, {
        variables: {
            "contentType": "Test",
            "courseName": course.preparingFor,
            "page": 1,
            "perPage": 1000
        },
    });
    // query2.data&&query2.data.liveTestList.filter(obj => new Date(obj.schedule) == new Date(query3.data.serverTime))
    query1.data && query1.data.liveTestList.filter(obj => {
        if (new Date(obj.schedule) == new Date(query3.data && query3.data.serverTime)) {
            return obj
        }
    })

    const showToastError = (message) => {
        toast.error(message);
    };
    useEffect(() => {       
        const getConfigData = async () => {
            try {
                const remoteData = await firebaseData('test_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setConfig(JSON.parse(remoteData));
                setRemoteLoading(false);
            } catch (error) {
                console.error('Error fetching remote data:', error);
                setRemoteLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
            getConfigData();
        }
    }, []);
    if (query1.loading || query2.loading || query3.loading) return (<><Loader /></>)
    if (query1.error || query2.error || query3.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED') || query2.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED') || query3.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR') || query2.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR') || query3.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        console.log(query1.error);
        console.log(query2.error);
        console.log(query3.error);
    }

    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: <ArrowButtonPrevious imgSrc={Icons.SliderLeft} imgAlt="previous-button" />,
        nextArrow: <ArrowButtonNext imgSrc={Icons.SliderLeft} imgAlt="next-button" />,
        responsive: [
            {
                breakpoint: 1081,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <div className="main_wrapper">
            <div className="breadcrumbs">
                <ul className="breadcrumb">
                    <li className="breadcrumb-item"><a >Home</a></li>
                    <li className="breadcrumb-item active"><a>Test</a></li>
                </ul>
            </div>
            <section className="videoLayer_wrapper qbanks_wrapper testLayer_wrapper section_side_padding">
                <div className="row">
                    <div className="col-lg-8 col-md-7 col-sm-12">
                        {
                            query1.data && query1.data.liveTestList.length !== 0 &&
                            <div className="recommended_video_wrapper">
                                <div className="subjects_header d-flex justify-content-between align-items-center">
                                    <h6>Live Test</h6>
                                    <div className="view_text">
                                        <Link to={`/view/all/test`}>
                                            <p><a >View All</a></p>
                                        </Link>
                                    </div>
                                </div>
                                <div className="recommend_video_details">
                                    <ul type="none" className="recommend_list">
                                        <Slider {...settings}>
                                            {

                                                query1.data && query1.data.liveTestList.filter(obj => obj.category != 'PostClassTest').map((d, i) => (
                                                    <li>
                                                        <Link to={`/testlayer/testinstruction/${d?._id}`}>
                                                            <div className="recommend_list_main d-flex align-items-center">
                                                                <figure className="user_img pos_rel">
                                                                    <img src={Images.Qbmark} alt="" className="img-fluid" />
                                                                    {
                                                                        d.purchaseStatus == 0 && (packageStatus?.isTrialUser === false && packageStatus?.activePackageLength === 0) &&
                                                                        <figcaption className="free_tag">
                                                                            <span>Free</span>
                                                                        </figcaption>
                                                                    }
                                                                    {
                                                                        d.purchaseStatus != 0 &&
                                                                        <figcaption className="free_tag">
                                                                            <span><img src={Icons.Lock} alt="Lock" className='img-fluid' />Pro</span>
                                                                        </figcaption>
                                                                    }
                                                                    <span className="text_qb">Test</span>
                                                                </figure>
                                                                <div className="recommend_list_content">
                                                                    <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                                                        <div className="continue_ttl">
                                                                            <h6>{d.title}</h6>
                                                                            <p>Expires on: <span>{moment(d.endTest).format("MMM DD hh:mm:ss A")}</span></p>
                                                                        </div>
                                                                        <div className="qbanks_rating">
                                                                            <span className="live_tag">
                                                                                <img src={Icons.RadioWave} alt="Star" className="img-fluid" /> Live
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="progress_details d-flex align-items-center">
                                                                        <div className="timer_progress test_timer">
                                                                            <img src={Icons.Clock} alt="" className="img-fluid" /><span>{`${getTestTime(d)}`}</span>
                                                                        </div>
                                                                        <div className="rightArrow_icn">
                                                                            <img src={Icons.TestArrow} alt="Play" className="img-fluid" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                ))
                                            }

                                            {/* <li>
                                        <div className="recommend_list_main d-flex align-items-center">
                                            <figure className="user_img pos_rel">
                                                <img src={Images.Qbmark} alt="" className="img-fluid" />
                                                <figcaption className="free_tag">
                                                    <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
                                                </figcaption>
                                                <span className="text_qb">Test</span>
                                            </figure>
                                            <div className="recommend_list_content">
                                                <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                                    <div className="continue_ttl">
                                                        <h6>Grand Test- Feb 220 (2022)</h6>
                                                        <p>Expires on: <span>03 March, at 4:30PM</span></p>
                                                    </div>
                                                    <div className="qbanks_rating">
                                                        <span className="live_tag">
                                                            <img src={Icons.RadioWave} alt="Star" className="img-fluid" /> Live
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="progress_details d-flex align-items-center">
                                                    <div className="timer_progress test_timer">
                                                        <img src={Icons.Clock} alt="" className="img-fluid"/><span>01:10:54</span> 
                                                    </div>
                                                    <div className="rightArrow_icn">
                                                        <img src={Icons.TestArrow} alt="Play" className="img-fluid" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="recommend_list_main d-flex align-items-center">
                                            <figure className="user_img pos_rel">
                                                <img src={Images.Qbmark} alt="" className="img-fluid" />
                                                <figcaption className="free_tag">
                                                    <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
                                                </figcaption>
                                                <span className="text_qb">Test</span>
                                            </figure>
                                            <div className="recommend_list_content">
                                                <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                                    <div className="continue_ttl">
                                                        <h6>Grand Test- Feb 220 (2022)</h6>
                                                        <p>Expires on: <span>03 March, at 4:30PM</span></p>
                                                    </div>
                                                    <div className="qbanks_rating">
                                                        <span className="live_tag">
                                                            <img src={Icons.RadioWave} alt="Star" className="img-fluid" /> Live
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="progress_details d-flex align-items-center">
                                                    <div className="timer_progress test_timer">
                                                        <img src={Icons.Clock} alt="" className="img-fluid"/><span>01:10:54</span> 
                                                    </div>
                                                    <div className="rightArrow_icn">
                                                        <img src={Icons.TestArrow} alt="Play" className="img-fluid" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="recommend_list_main d-flex align-items-center">
                                            <figure className="user_img pos_rel">
                                                <img src={Images.Qbmark} alt="" className="img-fluid" />
                                                <figcaption className="free_tag">
                                                    <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
                                                </figcaption>
                                                <span className="text_qb">Test</span>
                                            </figure>
                                            <div className="recommend_list_content">
                                                <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                                    <div className="continue_ttl">
                                                        <h6>Grand Test- Feb 220 (2022)</h6>
                                                        <p>Expires on: <span>03 March, at 4:30PM</span></p>
                                                    </div>
                                                    <div className="qbanks_rating">
                                                        <span className="live_tag">
                                                            <img src={Icons.RadioWave} alt="Star" className="img-fluid" /> Live
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="progress_details d-flex align-items-center">
                                                    <div className="timer_progress test_timer">
                                                        <img src={Icons.Clock} alt="" className="img-fluid"/><span>01:10:54</span> 
                                                    </div>
                                                    <div className="rightArrow_icn">
                                                        <img src={Icons.TestArrow} alt="Play" className="img-fluid" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="recommend_list_main d-flex align-items-center">
                                            <figure className="user_img pos_rel">
                                                <img src={Images.Qbmark} alt="" className="img-fluid" />
                                                <figcaption className="free_tag">
                                                    <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
                                                </figcaption>
                                                <span className="text_qb">Test</span>
                                            </figure>
                                            <div className="recommend_list_content">
                                                <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                                    <div className="continue_ttl">
                                                        <h6>Grand Test- Feb 220 (2022)</h6>
                                                        <p>Expires on: <span>03 March, at 4:30PM</span></p>
                                                    </div>
                                                    <div className="qbanks_rating">
                                                        <span className="live_tag">
                                                            <img src={Icons.RadioWave} alt="Star" className="img-fluid" /> Live
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="progress_details d-flex align-items-center">
                                                    <div className="timer_progress test_timer">
                                                        <img src={Icons.Clock} alt="" className="img-fluid"/><span>01:10:54</span> 
                                                    </div>
                                                    <div className="rightArrow_icn">
                                                        <img src={Icons.TestArrow} alt="Play" className="img-fluid" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li> */}
                                        </Slider>
                                    </ul>
                                </div>
                            </div>
                        }
                        <div className="other_reasource_wrapper">
                            <div className="subjects_header">
                                <h6>{config ? config?.testLanding.category.title : ''}</h6>
                                <div className="main_paragraph d-flex justify-content-between align-items-center">
                                    <p>{config ? config?.testLanding.category.description : ''}</p>
                                    <div className="view_text">
                                        <Link to={`/testlayer/All`} state={config?.testLanding?.category?.years}>
                                            <p><a>View All</a></p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="resource_main">
                                <div className="row">
                                    {/* test.testLanding.category.category.map */}
                                    {config != undefined && config?.testLanding?.category?.category?.filter(obj => obj.id != 'PostClassTest').map((d, i) => (
                                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                            <Link to={`/testlayer/${d.id}`} state={config?.testLanding?.category?.years}>
                                                <div className="resource_card d-flex">
                                                    <div className="resource_img_detail">
                                                        <figure className="res_img">
                                                            <img src={d.icon} alt="" className="img-fluid" />
                                                        </figure>
                                                        <h6>{d.title}</h6>
                                                        <p>{`${trimText(d)}...`}</p>
                                                    </div>
                                                    <div className="res_arrow">
                                                        <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))}
                                    {/* <div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res4} alt="" className="img-fluid" />
												</figure>
												<h6>Recall Question</h6>
												<p>Lörem ipsum bass tingen säde. Råponera nydade</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res5} alt="" className="img-fluid" />
												</figure>
												<h6>DBMCI</h6>
												<p>Lörem ipsum bass tingen säde. Råponera nydade</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res5} alt="" className="img-fluid" />
												</figure>
												<h6>T&D</h6>
												<p>Lörem ipsum bass tingen säde. Råponera nydade</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res5} alt="" className="img-fluid" />
												</figure>
												<h6>Mock Test- Scan</h6>
												<p>Lörem ipsum bass tingen säde. Råponera nydade</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5 col-sm-12" >
                        <div className="videos_wrapper">
                            <div className="recommended_video_wrapper qbanks_bookmark_questions testLayer_bookmarked_list">
                                <div id="accordion">
                                    <div className="accrodian_card">
                                        <div className="bookmark_ttl">
                                            <a href="#collapseOne" className="card_link pos_rel" data-toggle="collapse">
                                                <div className="subjects_header">
                                                    <h6><img src={Icons.BookmarkYellow} alt="Bookmark icon" className="img-fluid" /> Bookmarked Tests <span>({query2.data && query2.data.bookmarks.bookmarks.length})</span></h6>
                                                </div>
                                                <span className="bookmark_arrow">
                                                    <img src={Icons.BookmarkArrow} alt="" className="img-fluid" />
                                                </span>
                                            </a>
                                        </div>

                                        <div className="recommend_video_details collapse show" id="collapseOne" data-parent="#accordion">
                                            <ul type="none" className="recommend_list bookmarked_side_list">
                                                {query2.data != undefined && query2.data.bookmarks.bookmarks.map((d, i) => (
                                                    <li>
                                                        <Link to={`/testlayer/testinstruction/${d?.test?._id}`}>
                                                            <div className="recommend_list_main d-flex align-items-center">
                                                                <figure className="user_img pos_rel">
                                                                    <img src={Images.Qbmark} alt="" className="img-fluid" />
                                                                    {
                                                                        d.test.purchaseStatus == 0 && (packageStatus?.isTrialUser === false && packageStatus?.activePackageLength === 0) &&
                                                                        <figcaption className="free_tag">
                                                                            <span>Free</span>
                                                                        </figcaption>
                                                                    }
                                                                    {
                                                                        d.test.purchaseStatus != 0 &&
                                                                        <figcaption className="free_tag">
                                                                            <span><img src={Icons.Lock} alt="Lock" className='img-fluid' />Pro</span>
                                                                        </figcaption>
                                                                    }
                                                                    <span className="text_qb">Test</span>
                                                                </figure>
                                                                <div className="recommend_list_content bookmarked_list_content">
                                                                    <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                                                        <div className="continue_ttl">
                                                                            <h6>{d.test.title}</h6>
                                                                            <p>Expires on: <span>{moment(d.test.endTest).format("MMM DD hh:mm:ss A")}</span></p>
                                                                        </div>
                                                                        <div className="qbanks_rating">
                                                                            <span className="bookmark_delt" onClick={() => getBookmark({ variables: { resultId: d.test.progress ? d.test.progress._id : "", qbId: d.test._id, resultType: "Test", subjectId: d.subjectId, courseName: course.preparingFor, "status": false } })}>
                                                                                <img src={Icons.Delete} alt="Star" className="img-fluid" />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="progress_details d-flex align-items-center">
                                                                        <div className="timer_progress test_timer">
                                                                            <img src={Icons.Clock} alt="" className="img-fluid" /><span>{`${getTime(d.test)}`}</span>
                                                                        </div>
                                                                        <div className="rightArrow_icn">
                                                                            <img src={Icons.TestArrow} alt="Play" className="img-fluid" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                ))}
                                                {/* <li>
                                                    <div className="recommend_list_main d-flex align-items-center">
                                                        <figure className="user_img">
                                                            <span className="bookarks_qb">Q13</span>
                                                        </figure>
                                                        <div className="recommend_list_content">
                                                            <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                                                <div className="continue_ttl">
                                                                    <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                                </div>
                                                                <div className="qbanks_rating">
                                                                    <span>
                                                                        <img src={Icons.Delete} alt="Star" className="img-fluid" />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="progress_details d-flex align-items-center">
                                                                <div className="timer_progress">
                                                                    <p>Pathology</p>
                                                                </div>
                                                                <div className="rightArrow_icn">
                                                                    <img src={Icons.QbRightArrow} alt="Play" className="img-fluid" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}